<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                title="批量操作"
                :visible.sync="leaData.show"
                width="600px"
        >
            <div>
                <div class="w100 pl20 pr20">
                    <el-form label-width="100px" :model="resultData"  ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="意见" >
                            <el-input rows="5" v-model="resultData.opinion"
                                        type="textarea" placeholder="请输入意见"></el-input>
                        </el-form-item>
                    </el-form>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm" type="primary">确 定</el-button>
                <el-button @click="leaData.show = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {myAffSp} from '@/api/bpmnApi/bpmn';
    export default {
        name: "batchModel",
        components: {},
        props: {
            leaData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                resultData:{
                    approvalType: '',
                    instIds: '',
                    opinion:''
                },
            };
        },
        computed: {

        },
        methods: {
            // 确定提交
            submitForm () {
                myAffSp(this.resultData).then((res) =>{
                    if(res.data.code == '0'){
                        this.$message.success(  "操作成功!" );
                        this.leaData.show = false
                        this.$emit('close')
                    }else{
                        this.$message.warning(res.data.msg );
                    }
                }).catch(err=>{
                    this.$message.error(  "服务器异常!" );
                })
            },

        },
        watch: {
            "leaData.show": {
                handler(val) {
                    if (val) {
                        this.resultData = {
                                approvalType: this.leaData.type,
                                taskIds: this.leaData.taskIds,
                                opinion:''
                        }
                        }
                    }
                },
                deep: true
        },
    };
</script>

<style scoped lang="less">
    .msg-detail{
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 200px;
        overflow: auto;
        background: #F2F4F5;
        padding: 20px 0;
        .msg-item{
            padding: 2px 10px ;
            font-size: 12px;
            margin-top: 10px;

            .msg-str{
                display: inline-block;
                max-width: 60%;
                padding:5px 10px ;
                border-radius:6px;
                line-height: 20px;

            }
        }
        .other{
            .name-warp{
                margin-top: 10px;
                height: 20px;
                line-height: 20px;
                text-align: left;
                padding-left: 5px;
            }
            .str-warp{
                text-align: left;
                .msg-str{
                    background: #fff;
                    position: relative;
                    margin-left: 3px;
                    .msg-detail-load{
                        color: #2cacf0;
                        text-decoration: underline;
                        cursor: pointer;
                    }
                    &:before{
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        top: 5px;
                        border-right: 8px solid #fff;
                        left: -13px;


                    }
                }
            }

        }
        .self{
            .name-warp{
                margin-top: 10px;
                height: 20px;
                line-height: 20px;
                text-align: right;
                padding-right: 5px;
            }
            .str-warp{
                text-align: right;
                .msg-str{
                    background: #8CE050;
                    color: #fff;
                    position: relative;
                    margin-right: 3px;

                    &:after{
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        top: 5px;
                        border-left: 8px solid #8CE050;
                        right: -13px;

                    }



                }

            }

        }


    }
</style>
